import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';

/**
 * Where music24-api sends the artist after a sign-in that returns through it
 * (`ArtistPortalAuthKind.oauthCallback`).
 *
 * Always the Catalog screen, whatever screen started the sign-in: the Catalog
 * reads the outcome and opens the right card. `accountId` goes in the query so
 * the page opens on the artist the artist connected, not on the stored one.
 * The `/app` prefix is the router's basename (`smlHistory.tsx`).
 */
export function portalConnectReturnTo(accountId: number, origin: string = window.location.origin): string {
  return `${origin}/app/${SMLRoutes.catalog.join('/')}?accountId=${accountId}`;
}
